import MainResearch from "./MainResearch";
import PopularResearchList from "./PopularResearchList";
import CollectByStock from "./CollectByStock";
import CollectByKeyword from "./CollectByKeyword";
import AllResearchList from "./AllResearchList";
import BriefingAd from "./BriefingAd";

function FeedIndex({ isMobile }: { isMobile: boolean }) {
  return (
    <div className="bg-white w-full">
      <BriefingAd />
      <MainResearch isMobile={isMobile} />
      <PopularResearchList />
      <CollectByStock />
      <CollectByKeyword isMobile={isMobile} />
      <AllResearchList />
    </div>
  );
}

export default FeedIndex;
